<template>
  <div
    class="notifications-wrapper"
    @click="toggleDropdown"
    v-if="permiteNotificaciones"
  >
    <!-- Ícono campana -->
    <div class="bell-icon-wrap" :class="{ 'has-notif': notificaciones.length }">
      <i class="bx bxs-bell"></i>
      <span v-if="notificaciones.length" class="notif-badge">
        {{ notificaciones.length > 9 ? "9+" : notificaciones.length }}
      </span>
    </div>

    <!-- Panel de notificaciones -->
    <transition name="notif-fade">
      <div v-if="mostrarLista" class="notif-panel" @click.stop>
        <!-- Encabezado -->
        <div class="notif-header">
          <div class="notif-header-left">
            <i class="bx bxs-bell-ring notif-header-icon"></i>
            <span class="notif-header-title">Notificaciones</span>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span v-if="notificaciones.length" class="notif-count-pill">
              {{ notificaciones.length }} pendiente{{
                notificaciones.length > 1 ? "s" : ""
              }}
            </span>
            <button
              v-if="notificaciones.length"
              class="btn-notif-limpiar"
              @click.stop="limpiarTodas"
              title="Limpiar todas"
            >
              <i class="bx bx-trash"></i>
            </button>
          </div>
        </div>

        <!-- Sin notificaciones -->
        <div v-if="!notificaciones.length" class="notif-empty">
          <i class="bx bx-check-circle notif-empty-icon"></i>
          <p>Todo al día. No hay notificaciones.</p>
        </div>

        <!-- Lista -->
        <div class="notif-list">
          <div
            v-for="n in notificaciones"
            :key="n.IdNotificacion"
            class="notif-card"
          >
            <div class="notif-card-icon-wrap">
              <i class="bx bxs-calendar-exclamation notif-card-icon"></i>
            </div>
            <div class="notif-card-body">
              <p class="notif-card-titulo">{{ n.Titulo || "Recordatorio" }}</p>
              <!-- Números de habitación destacados -->
              <div v-if="n.NumeroHabitaciones && n.NumeroHabitaciones.length" class="notif-card-rooms mb-1">
                <i class="bx bxs-home-alt-2"></i>
                Hab. <strong>{{ n.NumeroHabitaciones.join(', ') }}</strong>
              </div>
              <p class="notif-card-mensaje">{{ n.Mensaje }}</p>
              <div class="notif-card-actions">
                <button
                  @click.stop="irAVistaRelacionada(n)"
                  class="btn-notif-ir"
                >
                  <i class="bx bx-right-arrow-alt"></i> Ver reserva
                </button>
                <button
                  @click.stop="marcarLeida(n.IdNotificacion)"
                  class="btn-notif-eliminar"
                  title="Eliminar notificación"
                >
                  <i class="bx bx-x"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Toast feedback -->
    <div
      v-if="mostrarToast"
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1055"
    >
      <div class="toast show text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i> {{ alerta.mensaje }}
          </div>
          <button
            type="button"
            class="btn-close btn-close-white me-2 m-auto"
            @click="cerrarToast"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
import { API_URL } from "@/config/config.js";

export default {
  name: "NotificacionesIcon",
  data() {
    return {
      notificaciones: [],
      mostrarLista: false,
      alerta: { mensaje: "", tipo: "success" },
      mostrarToast: false,
      polling: null,
      idRol: null, // ⚡️ Rol desde Vuex
    };
  },
  created() {
    // ✅ Toma IdRol directamente desde Vuex, igual que tu router
    this.idRol = store.getters.getUser?.IdRol;

    // Solo carga si está permitido
    if (this.permiteNotificaciones) {
      this.obtenerNotificaciones();
      this.polling = setInterval(this.obtenerNotificaciones, 60000); // cada minuto
    }
  },
  mounted() {
    document.addEventListener("click", this.cerrarDropdown);
  },
  beforeUnmount() {
    clearInterval(this.polling);
    document.removeEventListener("click", this.cerrarDropdown);
  },
  computed: {
    permiteNotificaciones() {
      return this.idRol === 2;
    },
    toastColor() {
      return (
        {
          success: "bg-success",
          danger: "bg-danger",
          warning: "bg-warning text-dark",
          info: "bg-info text-dark",
        }[this.alerta.tipo] || "bg-primary"
      );
    },
    iconoToast() {
      return (
        {
          success: "bi bi-check-circle-fill",
          danger: "bi bi-x-circle-fill",
          warning: "bi bi-exclamation-triangle-fill",
          info: "bi bi-info-circle-fill",
        }[this.alerta.tipo] || "bi bi-info-circle-fill"
      );
    },
  },
  methods: {
    async obtenerNotificaciones() {
      try {
        const res = await axios.get(`${API_URL}/notificaciones/hoy`);
        this.notificaciones = res.data;
      } catch (error) {
        this.mostrarToastMensaje("Error al cargar notificaciones", "danger");
      }
    },
    async marcarLeida(id) {
      try {
        await axios.post(`${API_URL}/notificaciones/${id}/marcar-leida`);
        this.mostrarToastMensaje("Notificación marcada como leída");
        await this.obtenerNotificaciones();
      } catch (error) {
        this.mostrarToastMensaje("Error al marcar como vista", "danger");
      }
    },
    toggleDropdown() {
      this.mostrarLista = !this.mostrarLista;
    },
    cerrarDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.mostrarLista = false;
      }
    },
    irAVistaRelacionada(notificacion) {
      const id = notificacion.IdReserva;
      // Cerrar dropdown antes de navegar
      this.mostrarLista = false;

      if (id) {
        this.$router.push({ name: "ValidarDiaExtraF", params: { id } })
          .catch((err) => {
            // Ignorar error de navegación duplicada (misma ruta)
            if (err?.name !== 'NavigationDuplicated') console.warn(err);
          });
      } else {
        this.mostrarToastMensaje("No se puede redirigir: falta ID", "warning");
      }
    },
    async limpiarTodas() {
      try {
        await axios.post(`${API_URL}/notificaciones/marcar-todas-leidas`);
        this.notificaciones = [];
        this.mostrarToastMensaje("Notificaciones limpiadas");
      } catch {
        this.mostrarToastMensaje("Error al limpiar notificaciones", "danger");
      }
    },
    mostrarToastMensaje(mensaje, tipo = "success") {
      this.alerta.mensaje = mensaje;
      this.alerta.tipo = tipo;
      this.mostrarToast = true;
      setTimeout(() => {
        this.mostrarToast = false;
      }, 3000);
    },
    cerrarToast() {
      this.mostrarToast = false;
    },
  },
};
</script>

<style scoped>
/* ── Wrapper ── */
.notifications-wrapper {
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  user-select: none;
}

/* ── Campana ── */
.bell-icon-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  transition: background 0.2s;
  color: #fff;
  font-size: 20px;
}
.bell-icon-wrap:hover {
  background: rgba(255, 255, 255, 0.15);
}
.bell-icon-wrap.has-notif i {
  animation: bell-shake 1.2s ease infinite;
}
@keyframes bell-shake {
  0%,
  100% {
    transform: rotate(0deg);
  }
  15% {
    transform: rotate(14deg);
  }
  30% {
    transform: rotate(-10deg);
  }
  45% {
    transform: rotate(8deg);
  }
  60% {
    transform: rotate(-6deg);
  }
  75% {
    transform: rotate(4deg);
  }
}

/* ── Badge ── */
.notif-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  background: #ef4444;
  color: #fff;
  border-radius: 9999px;
  font-size: 10px;
  font-weight: 700;
  min-width: 17px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  border: 2px solid transparent;
  line-height: 1;
}

/* ── Panel ── */
.notif-panel {
  position: absolute;
  right: 0;
  top: 46px;
  width: 360px;
  max-height: 480px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 1050;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e7eb;
}

/* ── Encabezado ── */
.notif-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 12px;
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  color: #fff;
  flex-shrink: 0;
}
.notif-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.notif-header-icon {
  font-size: 20px;
}
.notif-header-title {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.01em;
}
.notif-count-pill {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 9px;
}
.btn-notif-eliminar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid #e74c3c;
  color: #e74c3c;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 0.82rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  line-height: 1;
}
.btn-notif-eliminar:hover {
  background: #e74c3c;
  color: #fff;
}

.btn-notif-limpiar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.35);
  border-radius: 7px;
  color: #fff;
  font-size: 14px;
  padding: 3px 7px;
  cursor: pointer;
  transition: background 0.15s;
}
.btn-notif-limpiar:hover {
  background: rgba(255,255,255,0.3);
}
.notif-card-rooms {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  font-size: 12px;
  color: #1e40af;
  padding: 2px 8px;
}

/* ── Sin notificaciones ── */
.notif-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #9ca3af;
  gap: 10px;
}
.notif-empty-icon {
  font-size: 42px;
  color: #bbf7d0;
}
.notif-empty p {
  margin: 0;
  font-size: 13px;
  text-align: center;
}

/* ── Lista ── */
.notif-list {
  overflow-y: auto;
  padding: 10px 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.notif-list::-webkit-scrollbar {
  width: 5px;
}
.notif-list::-webkit-scrollbar-track {
  background: #f1f5f9;
}
.notif-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 99px;
}

/* ── Tarjeta ── */
.notif-card {
  display: flex;
  gap: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 4px solid #3b82f6;
  border-radius: 10px;
  padding: 12px 13px;
  transition: box-shadow 0.15s, background 0.15s;
}
.notif-card:hover {
  background: #eff6ff;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.12);
}
.notif-card-icon-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
}
.notif-card-icon {
  font-size: 22px;
  color: #3b82f6;
}
.notif-card-body {
  flex: 1;
  min-width: 0;
}
.notif-card-titulo {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #1e40af;
  margin: 0 0 4px;
}
.notif-card-mensaje {
  font-size: 13px;
  color: #374151;
  line-height: 1.5;
  margin: 0 0 10px;
  word-break: break-word;
}
.notif-card-actions {
  display: flex;
  gap: 6px;
}
.btn-notif-ir {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 12px;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
}
.btn-notif-ir:hover {
  background: #1d4ed8;
  transform: translateY(-1px);
}
.btn-notif-ir i {
  font-size: 15px;
}

/* ── Animación panel ── */
.notif-fade-enter-active,
.notif-fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.notif-fade-enter-from,
.notif-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px) scale(0.97);
}
</style>
